import { Wrapper, MessageText, DetailText, $Icon, InfoBox } from './Toast.parts';
import type { ToastProps } from './Toast.types';
export * from './Toast.types';

export function Toast(props: ToastProps) {
	return (
		<Wrapper {...props}>
			<$Icon name="IconInfoWhite" />
			<InfoBox>
				<MessageText>{props.opts.message}</MessageText>
				{!!props.opts.details && <DetailText>{props.opts.details}</DetailText>}
			</InfoBox>
		</Wrapper>
	);
}
